import React from 'react'
import QueueAnim from "rc-queue-anim";
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import { OverPack } from "rc-scroll-anim";
import { getEnter } from '@/utils'
import "./index.less";
const CastList = (props) => {
	const { caseList, className } = props || {};
  return (
		<div className={`case-list-box ${className}`}>
			{
				caseList.map((item, index) => (
					<OverPack key={`queue-${index}`} style={{ minHeight: 90 }} always={true} playScale={[0.2, 0.8]}>
						<QueueAnim
							interval={120}
							leaveReverse
							type="bottom"
							component={"div"}
						>
							<div className="case-li" key={`case-li-${index}`}>
								<div className="case-li-left">
									<img src={item.img} alt="" className="case-li-img" />
									{
										item.type && (
											<div className="case-li-type" style={{ background: item.typeBg }}>
												{item.type}
												{/* <Texty className="case-li-content" type="swing-rotate" mode="smooth">
													{item.type}
												</Texty> */}
											</div>
										)
									}
								</div>
								<div className="case-li-right">
									<div className="case-li-title">{item.title}</div>
									{/* <Texty enter={getEnter} leave={getEnter} className="case-li-title">
										{item.title}
									</Texty> */}
									{/* <Texty type="bottom" mode="sync" className="case-li-content">
										{item.content}
									</Texty> */}
									<div className="case-li-content">{item.content}</div>
									{ item.time && <div className="case-li-time">{item.time}</div> }
								</div>
							</div>
						</QueueAnim>
					</OverPack>
				))
			}
		</div>
  )
}

export default CastList;
